import React from 'react';
import { Check } from 'lucide-react';
import { services } from '../data/services';
export function Services() {
  return <section id="services" className="w-full bg-[#F4F4F1] py-16 lg:py-24" data-id="element-59" data-mp="1hwxmikg9gsl9">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-10" data-id="element-60" data-mp="1dtj1ffdgtm0y">
        <div className="flex flex-col gap-4 border-b-4 border-[#0B1B3A] pb-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-61" data-mp="1dvvlpz6p48h6">
          <h2 className="font-heading text-4xl font-black uppercase leading-none tracking-tight text-[#0B1B3A] lg:text-5xl" data-id="element-62" data-mp="13vl8wfokp32j">
            What we paint
          </h2>
          <p className="max-w-md text-[#0B1B3A]/70" data-id="element-63" data-mp="z31szc2exvuk">
            Homes, rentals and small commercial spaces — inside and out. If it
            needs paint, ask us.
          </p>
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-64" data-mp="q2ddecxdfnfk">
          {services.map(service => <article key={service.title} className="bg-white p-6 shadow-sm" data-id="element-65" data-mp="l77rvf7vsas0">
              <h3 className="font-heading text-xl font-black uppercase tracking-tight text-[#0B1B3A]" data-id="element-66" data-mp="g728embrlul0">
                {service.title}
              </h3>
              <ul className="mt-4 space-y-2.5" data-id="element-67" data-mp="3b3pq4umiun83">
                {service.items.map(item => <li key={item} className="flex items-start gap-2 text-sm text-[#0B1B3A]/75" data-id="element-68" data-mp="2xcb8os89iu35">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#0B1B3A]" aria-hidden="true" data-id="element-69" data-mp="328rwtmfgp8g8" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}